<template>
<widget title="Company Addresses">
	<table-list
		record-name="Address"
		:fields="fields"
		:records="mutatedAdresses"
		:has-delete="true"
		delete-endpoint="CompanyAddress/delete"
		:has-edit="true"
		:sortable="true"
		v-on:edit="editAddress"
		v-on:modelChange="fetchAddresses">

		<button class="btn btn-success" v-on:click="addAddress">
			<i class="fa fa-plus"></i>
			Add Address
		</button>

	</table-list>

	<modal-dialog :modal-visible="editModal.visible"
		:title="editModal.title"
		confirm-button-text="Save"
		:working="editModal.working"
		button-class="btn-success"
		v-on:closeModal="editModal.visible = false"
		v-on:confirm="saveAddress">

		<field label="Place Name"
			col-class="col-md-4"
			:params="{type:'text',required:true}"
			v-model="editModal.payload.place_name"
			:invalid="$store.errorList.place_name">
		</field>

		<field label="Address"
			col-class="col-md-4"
			:params="{type:'text',required:true}"
			v-model="editModal.payload.address"
			:invalid="$store.errorList.address">
		</field>

		<field label="City"
			col-class="col-md-4"
			:params="{type:'text',required:true}"
			v-model="editModal.payload.city"
			:invalid="$store.errorList.city">
		</field>

		<field label="Province/State"
			col-class="col-md-4"
			:params="{type:'province',required:true}"
			v-model="editModal.payload.province"
			:invalid="$store.errorList.province">
		</field>

		<field label="Country"
			   col-class="col-md-4"
			   :params="{type:'text',required:true}"
			   v-model="editModal.payload.country"
			   :invalid="$store.errorList.country">
		</field>

		<field label="Postal Code/Zip"
			col-class="col-md-4"
			:params="{type:'text',required:true}"
			v-model="editModal.payload.postal_code"
			:invalid="$store.errorList.postal_code">
		</field>

		<field label="Phone #"
			col-class="col-md-4"
			:params="{type:'text'}"
			v-model="editModal.payload.phone">
		</field>

	</modal-dialog>
</widget>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"

export default {
	name: "CompanyAddresses",
	components: {
		Field,
		Widget,
		TableList,
		ModalDialog
	},
	data() {
		return {
			fields: [
				{text: 'Place Name',key:'place_name'},
				{text: 'Address',key: 'addressCondensed'},
				{text: 'Phone',key: 'phone'}
			],
			addresses: [],
			editModal: {
				visible: false,
				title: "Add Address",
				payload: {},
				working: false
			}
		}
	},
	computed: {
		mutatedAdresses() {
			return this.addresses.map(addr => {
				addr.addressCondensed = addr.address+"<br>"+addr.city+", "+addr.province+"<br>"+addr.country+"<br>"+addr.postal_code

				return addr
			})
		}
	},
	methods: {
		saveAddress() {
			let vm = this

			this.editModal.working = true

			this.postData("CompanyAddress/save",this.editModal.payload,true).then(response => {
				this.editModal.working = false

				if (response.success) {
					vm.fetchAddresses()
					vm.editModal.visible = false
					vm.editModal.payload = {}
				}
			})
		},
		editAddress(address) {
			this.editModal.visible = true
			this.editModal.payload = JSON.parse(JSON.stringify(address))
			this.editModal.title = "Edit Address"
		},
		addAddress() {
			this.editModal.visible = true
			this.editModal.title = "Add New Address"
			this.editModal.payload = {}
		},
		fetchAddresses() {
			let vm = this

			this.getJSON("CompanyAddress/get",{},true).then(response => {
				if (response.success) {
					vm.addresses = response.data
				}
			})
		}
	},
	created() {
		this.fetchAddresses()
	}
}
</script>